interface DriftPayload {
  isOnline: boolean; // is the widget "online"
  sidebarOpen: boolean; // was the sidebar opened at widget launch
  teamAvailability: object;
  widgetVisible: boolean; // is the widget visible based on the drift display settings to the user (excludes any manual css overrides)
}

const resetDrift = () => {
  const timeoutId = setInterval(() => {
    if ('drift' in window) {
      clearInterval(timeoutId);
      window.drift.on('ready', (_: any, payload: DriftPayload) => {
        if (!payload.sidebarOpen) {
          // Register new page change
          window.drift.page();
          const widget = document.querySelector('#drift-widget-container');
          if (widget) {
            // If user has not interacted with bot hide widget
            (widget as HTMLDivElement).style.display = 'none';
          }
        }
        window.drift.on('message', () => {
          const widget = document.querySelector('#drift-widget-container');
          if (widget) {
            (widget as HTMLDivElement).style.display = 'block';
          }
        });
      });
    }
  }, 100);
};

export { resetDrift };
